angular.module('impactx.passwordrecovery').controller('CustomPasswordRecoveryCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    '$mdDialog',
    'LegalLinking',
    'AppConfiguration',
    'LoginService',
    '$redirect',
    CustomPasswordRecoveryCtrl]);

function CustomPasswordRecoveryCtrl($scope, dataGen, $routeParams, $mdDialog, LegalLinking, AppConfiguration, LoginService, $redirect) {
    $scope.currentYear = AppConfiguration.get('copyRightYear');
    $scope.imprintURL = AppConfiguration.get('imprintURL');
    $scope.privacyPolicy = AppConfiguration.get('privacyPolicy');
    $scope.generalTerms = AppConfiguration.get('generalTerms');
    $scope.removeCopyRight = AppConfiguration.get('removeCopyRight');

    LoginService.getCustomLoginData($routeParams.hash).then(function(data) {
        if(isEmpty(data)) {
            $redirect.redirectTo(null, "/passwordrecovery/" + $routeParams.osuTAN);
        }
        else {
            $scope.data = data;
            dataGen.getData({}, {osuTAN: $routeParams.osuTAN}, "/passwordrecovery/validaterequest").then(function (data) {
                $mdDialog.show({
                    templateUrl: 'modules/passwordrecovery/templates/passwordrecovery.dialog.html',
                    controller: 'CustomPasswordRecoveryDialogCtrl',
                    controllerAs: "passwordRecoveryDialogCtrl",
                    locals: {
                        passwordRecoveryData: data,
                        customHash: $routeParams.hash,
                        customLogoURL: $scope.data.logo
                    },
                    clickOutsideToClose: false,
                    escapeToClose: false,
                    fullscreen: false,
                });
            });
        }
    });

    var isEmpty = function isEmpty(ob) {
        for (var i in ob) {
            if (ob.hasOwnProperty(i)) {
                return false;
            }
        }
        return true;
    };

    $scope.openDialog = function (ev, link, title) {
        LegalLinking.openDialog(ev, link, title);
    };
}